module.exports = __webpack_public_path__ + "static/105-f396c86aa2687fd98b2f6775d457f8dd.png";